import { ViewMoreButton, UpArrow, DownArrow } from './styles';

const ExpandButton = ({ isExpanded, toggleExpand }) => {
  return (
    <ViewMoreButton onClick={() => toggleExpand()}>
      {isExpanded ? 'VIEW LESS' : 'VIEW MORE'}
      {isExpanded ? <UpArrow /> : <DownArrow />}
    </ViewMoreButton>
  );
};

export default ExpandButton;
